// extracted by mini-css-extract-plugin
export var active = "_t5-1";
export var circle = "_t5-0";
export var completed = "_t5-2";
export var connector = "_t5-4";
export var connectorCompleted = "_t5-7";
export var connectorSpacer = "_t5-5";
export var iconStrokeOverride = "_t5-8";
export var labelContainer = "_t5-6";
export var pending = "_t5-3";